// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__CKubO","containerItemsCenter":"Skeleton_containerItemsCenter__2uGiq"};